import { Component, OnInit } from '@angular/core';
import {transition, trigger, useAnimation} from '@angular/animations';
import {fadeInDown} from 'ng-animate';
import { FormBuilder, NgForm, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';

@Component({
  selector: 'hybse-admin-addnews',
  templateUrl: './addnews.component.html',
  styleUrls: ['./addnews.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class AddnewsComponent implements OnInit {
  public fadeInDown: any;
  createNewsForm: FormGroup;
  formResponseMsg: string = '';
  alertStatusMessage: boolean;
  showLoader: boolean = false;
  formSubmitted: boolean = false;

  constructor(private _fb: FormBuilder,
              private _req: ApirequestService,
              private _urls: ApiurlsService,
              private _utils: UtilityService,
              private route: ActivatedRoute,
              private router: Router) { }

  createNews() {
    const formVal = this.createNewsForm.value;
    this.formSubmitted = true;
    let seed = this;
    if (this.createNewsForm.valid) {
      this.showLoader = true;
      const data: any = {
        title: formVal.title,
        href: formVal.link,
      };

      this._req.fetchApiData(this._urls.newsCreateUrl, data).subscribe(
        (data: any) => {
          const response = data.data;
          const responseErr = data.error;
          this.showLoader = false;
          this.formSubmitted = false;
          this._utils.scrollToY(0, 400, 'easeInOutQuint');
          if (response != '') {
            this.formResponseMsg = 'News has been created Successfully';
            this.alertStatusMessage = true;
            this.cancelNewsCreate();
          }
          if (responseErr !== '') {
            this.formResponseMsg = responseErr['Error Msg'];
            this.alertStatusMessage = false;
          }
        },
        error => {
        },
        () => {
        });
    }
  }

  createNewsFormInit() {
    this.createNewsForm = this._fb.group({
        'title': ['', [Validators.required]],
        'link': ['']
      },
      { updateOn: 'submit' }
    );

  }

  cancelNewsCreate() {
    this.router.navigate(['/news/lists']);
  }

  ngOnInit() {
    this.createNewsFormInit();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/company/addnews/addnews.component.ts